













import { Component, Vue, Prop } from 'vue-property-decorator';
import RequirementItem from './requirementItem.vue';
import CollapseBox from '@/components/collapseBox/collapseBox.vue';
import { classifyDataByKey, generateClassifications, ICollapseInfo, mergeClassifiedData } from '@/components/collapseBox/collapseBoxUtils';
import { AccountModule } from '@/store/modules/account';

type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;

@Component({
  components: {
    RequirementItem,
    CollapseBox,
  },
})
export default class RequirementList extends Vue {
  @Prop({ required: true, default: () => [] })
  private data!: IRequirementInfo[];
  @Prop({ default: '' }) private activeId!: string;
  @Prop({ default: false }) private spinning!: boolean;
  private viewDetail(requirment: IRequirementInfo) {
    this.$emit('click', requirment);
  }
  get classifyDataByAccount() {
    // 根据账号对应的projects 生成 分类数据
    return generateClassifications(AccountModule.projects, 'id', 'name');
  }
  get dataByProjectCategory(): ICollapseInfo[] {
    const classifyData = classifyDataByKey(this.data, 'projectId', 'projectName');
    return mergeClassifiedData(this.classifyDataByAccount, classifyData);
  }
}
